import React from 'react'
import ExportPropertiesExcel from './ExportPropertiesExcel'
import ExportContactExcel from './ExportContactExcel'

function ExcNew() {
  return (
    <div>
        <div className="album py-0">
                <div className="container">
        <br/>
        <ExportPropertiesExcel/>
        <ExportContactExcel/>
        
        </div>
        </div>
        <br/>
    </div>
  )
}

export default ExcNew